import { inject, Pipe, PipeTransform } from '@angular/core';
import { LocaleService } from './locale.service';

@Pipe({
  name: 'translate',
  pure: false // Impure pipe runs frequently to pick up translation changes
})
export class TranslatePipe implements PipeTransform {
  private readonly _localeService = inject(LocaleService);

  public transform(key: string, params?: Record<string, string>): string {
    return this._localeService.translate(key, params);
  }
}
